import React, { useState } from "react";
import { Link } from "react-router-dom";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import h1 from "../assets/h1.jpg";
import h2 from "../assets/h2.jpg";
import h3 from "../assets/h3.jpg";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import QuoteDialog from "./QuoteDialog";
const carouselItems = [
  "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/ngo-carousel/image-1.jpg",
  "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/ngo-carousel/image-2.jpg",
  "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/ngo-carousel/image-3.jpg",
  "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/ngo-carousel/image-4.jpg",
  "https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/ngo-carousel/image-5.jpg",
];

const Hero = () => {
  const [dialogState, setDialogState] = useState(false);
  const toggleDialog = (e) => {
    setDialogState((prev) => !prev);
  };
  const handleKeyClose = (e) => {
    if (e.key === "Escape") {
      setDialogState(false);
      document.body.style.overflow = "auto";
    }
  };
  return (
    <section
      className="bg-white antialiased"
      onKeyDown={(e) => handleKeyClose(e)}>
      <QuoteDialog state={dialogState} toggle={toggleDialog} />
      <div className="h-[calc(100vh-200px)] max-h-[700px] min-h-[400px]">
        <Slider toggleDialog={toggleDialog} />
      </div>
    </section>
  );
};

export default Hero;

const AutoplaySlider = withAutoplay(AwesomeSlider);
const Slider = ({ toggleDialog }) => {
  return (
    <AutoplaySlider
      play={true}
      cancelOnInteraction={false}
      interval={5000}
      bullets={false}
      className="h-full">
      {sliderContent.map((item, index) => {
        return (
          <div
            key={index}
            data-src={item.image}
            className="z-0 flex justify-start items-start w-full max-screen">
            <div
              className="relative ml-4 bg-primary/80 rounded-2xl text-white z-10 
        max-w-[400px] p-12 flex flex-col gap-4 animate__animated animate__bounce animate__animated animate__fadeInLeft animate__delay-1s">
              <div className="animate__animated animate__fadeIn animate__delay-2s">
                <p className="text-lg font-normal tracking-wider">
                  {item.title1}
                </p>
                <h1 className="text-3xl font-bold tracking-wider">
                  {item.title2}
                </h1>
              </div>
              <p className="text-neutral-11 animate__animated animate__fadeInUpBig animate__delay-2s ">
                {item.description}
              </p>
              {index === 0 ? (
                <button
                  onClick={toggleDialog}
                  className="btn flex-c bg-white text-primary  hover:bg-neutral-9 animate__animated animate__fadeInLeft animate__delay-3s animate__slow">
                  {item.button}
                </button>
              ) : (
                <Link
                  to={item.link}
                  className="btn flex-c bg-white text-primary  hover:bg-neutral-9 animate__animated animate__fadeInLeft animate__delay-3s animate__slow">
                  {item.button}
                </Link>
              )}

              <div className="absolute w-full h-full bg-primary/80 rounded-2xl -z-10 top-4 right-4"></div>
            </div>
          </div>
        );
      })}
    </AutoplaySlider>
  );
};

const sliderContent = [
  {
    image: h1,
    title1: "We are Providing The Best",
    title2: "Elevating Outdoor Spaces Since 1978",
    description:
      "Experience the transformation of your gardens and lawns with our unrivaled gardening and landscaping services spanning generations.",
    button: "Get a Quote",
    link: "/quote",
  },
  {
    image: h2,
    title1: "",
    title2: "Sculpting Nature's Canvas: Landscapes That Inspire",
    description:
      "Transforming spaces into captivating landscapes, a testament to four decades of artistic excellence.",
    button: "Learn More",
    link: "/about",
  },
  {
    image: h3,
    title1: "",
    title2: "Lawn Perfection: A Legacy of Green Excellence",
    description:
      "Nurturing vibrant lawns with trusted expertise, ensuring a lush, healthy canvas for your outdoor haven.",
    button: "Learn More",
    link: "/about",
  },
];
